import { Div, Ref, Button, Text, Span } from "@tblabs/truffle";


export class AmountControl extends Div
{
    constructor(quantity: Ref<number>)
    {
        super("cart-summary__item-row-qty-controls");

        this.Append(
            new Button().Class("cart-summary__quantity-btn")
                .Attribute("aria-label", "Zmniejsz ilość")
                .Text("-")
                .OnClick(() => quantity.value > 1 ? quantity.value-- : 1),
            new Text(quantity).Class("cart-summary__quantity-value"),
            new Button().Class("cart-summary__quantity-btn")
                .Attribute("aria-label", "Zwiększ ilość")
                .Text("+")
                .OnClick(() => quantity.value++),
            new Span("cart-summary__item-unit").Text("szt.")
        );
    }
}
